import styled from 'styled-components/macro';
import ComponentControls from 'components/styled/ComponentControls/ComponentControls';
import { TickLine } from 'components/Overview/LineChart/shared.style';
import { definitionLabel } from 'styles/base-classes';
import { numbersTypography } from 'styles/global/typography/typography';
import { Label } from 'components/base/RadioGroup/RadioGroup';
import { FakeDropdownWrapper } from 'components/base/SkeletonLoader/FakeInteractive';

export const ControlWrapper = styled(ComponentControls)`
  justify-content: flex-end;

  ${Label} {
    font-size: 16px;
  }

  ${FakeDropdownWrapper} {
    flex-basis: auto;
  }
`;

export const TrendsWrapper = styled('div')<any>`
  margin: 1.5rem;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: ${({ isLoader }): string => (isLoader ? '50px' : '40px')};
  justify-content: space-between;

  @media screen and (max-width: 980px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media screen and (max-width: 36em) {
    grid-template-columns: repeat(1, 1fr);
    grid-gap: 30px;
  }
`;

export const LightTickLine = styled(TickLine)`
  stroke: ${({ theme }): string => theme.LightGrey};

  @media screen and (max-width: 36em) {
    stroke: ${({ theme }): string => theme.Grey};
  }
`;

export const GendersWrapper = styled('div')`
  margin: 1.5em 1.5em 0;

  @media screen and (max-width: 660px) {
    display: flex;
    justify-content: space-between;
    margin-bottom: -10px;
  }

  @media screen and (max-width: 500px) {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
  }
`;

export const GenderLabel = styled('span')`
  ${definitionLabel};
  display: inline-flex;
  flex-flow: row nowrap;
  align-items: flex-end;
  margin-bottom: 0.25em;
  font-weight: 600;
  margin-right: 36px;
  cursor: default;

  @media screen and (max-width: 660px) {
    margin: 10px 0 20px;
  }

  @media screen and (max-width: 500px) {
    margin-right: 20px;
    font-size: 12px;
  }
`;

export const BoxTitle = styled('span')`
  ${definitionLabel};
  font-size: 10px;
  font-weight: 600;

  @media screen and (max-width: 36em) {
    font-size: 12px;
  }
`;

export const AgeTitle = styled('div')`
  color: ${({ theme }): string => theme.ShadowBlack};
  ${numbersTypography};
  font-weight: 600;
  font-size: 29px;
`;

export const TrendWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  height: 175px;

  @media screen and (max-width: 36em) {
    height: auto;

    &:not(:last-of-type) {
      padding-bottom: 15px;
      border-bottom: ${({ theme }): string => `1px solid ${theme.LightGrey}`};
    }
  }
`;
